(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('AdvertisingSourceDetailController', AdvertisingSourceDetailController);

    /* Added UIFormAccess
    AdvertisingSourceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AdvertisingSource', 'CloudPBX'];

    function AdvertisingSourceDetailController($scope, $rootScope, $stateParams, previousState, entity, AdvertisingSource, CloudPBX) {
    */
    AdvertisingSourceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AdvertisingSource', 'CloudPBX', 'UIFormAccess'];

    function AdvertisingSourceDetailController($scope, $rootScope, $stateParams, previousState, entity, AdvertisingSource, CloudPBX, UIFormAccess) {
        var vm = this;

        vm.advertisingSource = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:advertisingSourceUpdate', function(event, result) {
            vm.advertisingSource = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
